import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TGetSingleCardInfoRequestSchema,
  TGetSingleCardInfoResponseSchema,
} from "./getSingleCardInfo.schema";

export const getSingleCardInfo = (axios: IAxiosInstance) => {
  return async (params: TGetSingleCardInfoRequestSchema) => {
    const { card_id } = params;

    const response = await axios.noRetry.get<
      IApiResponse<TGetSingleCardInfoResponseSchema>
    >(`/api/push-to-card/card-info/${card_id}`);

    return response.data;
  };
};
